import BG from '@/assets/fcm-bottom.png'

export default function BottomBar() {
	return (
		<div className="absolute bottom-0 left-0 w-full">
			<img src={BG} className="h-auto w-full sm:rounded-b-2xl" alt="" />
		</div>
	)
}
